// extracted by mini-css-extract-plugin
module.exports = {"shadowSvg":"FallbackGradient_shadowSvg__nWXMi"};